import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import { Box, Container } from '@material-ui/core';
import {
  comprehensiveWaterSolutions,
  directionalDrillingExcellence,
  waterDistribution,
  waterDistributionExpertise,
  waterServiceHeader,
  waterUtilityServices,
} from 'images/expertise/water-service';
import WaterServiceItem, { WaterLine } from '../components/structures/expertise/WaterServiceItem';

const data = [
  {
    title: 'Water Distribution',
    description:
      'Our water distribution services focus on ensuring a reliable and efficient supply of water to meet the needs of residential, commercial, and industrial customers. We design and implement systems that optimize water flow, pressure, and quality, integrating advanced technologies to monitor and manage the distribution network effectively.',
    image: waterDistribution,
  },
  {
    title: 'Directional Drilling Excellence',
    description:
      'We specialize in directional drilling, using advanced equipment to ensure minimal ground disruption. Our commitment to cutting-edge technology, safety, and rigorous training ensures outstanding performance and client satisfaction.',
    image: directionalDrillingExcellence,
  },
  {
    title: 'Comprehensive Water Solutions',
    description:
      'Utilities One delivers extensive water utility services, including installing, maintaining, and servicing water infrastructure. Our expertise spans constructing new systems, enhancing existing plants, and installing diverse piping, fire hydrants, valves, services, and meters for residential, commercial, and industrial clients.',
    image: comprehensiveWaterSolutions,
  },
  {
    title: 'Emergency Response and Maintenance',
    description:
      'Our dedicated team is available 24/7 to respond to emergencies and maintain water utility systems. We prioritize quick, efficient solutions to minimize downtime and restore services promptly. Regular maintenance programs ensure the longevity and reliability of your water infrastructure.',
    image: waterDistributionExpertise,
  },
  {
    title: 'Customer-Centric Approach',
    description:
      'At Utilities One, we value our customers and pride ourselves on our customer-centric approach. We work closely with clients to understand their unique needs and provide tailored solutions, making you feel valued and heard. We aim to exceed expectations through exceptional service, innovative solutions, and a commitment to excellence.',
    image: waterUtilityServices,
  },
];

const Expertise: NextPage = () => {
  return (
    <>
      <Header
        title="Water Utility Services"
        description={
          <>
            Offering comprehensive turnkey services, from initial blueprints to ongoing
            <br />
            maintenance, ensuring efficient and reliable water infrastructure for any needs.
          </>
        }
        image={waterServiceHeader}
      />

      <Container fixed data-aos="fade-up" data-aos-delay="400">
        <WaterLine />
        {data.map((item, index) => (
          <WaterServiceItem
            key={index}
            title={item.title}
            description={item.description}
            image={item.image}
            reverse={index % 2 === 1}
          />
        ))}
      </Container>
      <Box mt={20} />
    </>
  );
};

export default Expertise;
